import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TextNodeType } from '@mwe/models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-basic-card-title',
  templateUrl: './basic-card-title.component.html',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicCardTitleComponent {
  iconClass = input<string>();
  cardTitle = input<string>();
  cardTitleParams = input();
  headingNodeType = input<TextNodeType>('h5');
}
